import { render, staticRenderFns } from "./WarehouseAllocationNewRulesActionsDialog.vue?vue&type=template&id=652df780"
import script from "./WarehouseAllocationNewRulesActionsDialog.vue?vue&type=script&lang=js"
export * from "./WarehouseAllocationNewRulesActionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports